import React, { createRef, useState } from 'react';
import { withTranslation } from 'react-i18next';
import {Button, Dropdown, Checkbox, Modal, Input, Message, Form, TextArea} from 'semantic-ui-react';

import {colors, fontSizes, fonts, spacings, shadow, buttons} from 'style';
import DatabaseService from 'services/DatabaseService.js';
import { useDispatch } from 'react-redux';
import { SET_LOADING_OVERLAY_ENABLE } from 'actions/types/index.js';

const BONUS_GEMS_BATCH_SIZE = 100

function splitCsvDataLines(csvData) {
    if (!csvData) return []
    const normalized = csvData.replace(/\r\n/g, '\n')
    let lines = normalized.split('\n')
    if (lines.length && lines[lines.length - 1] === '') {
        lines = lines.slice(0, -1)
    }
    return lines
}

function joinCsvDataLines(lines) {
    return lines.join('\r\n')
}

var style = {
    content: {
        fontSize: fontSizes.body,
        lineHeight: '1.5',
        backgroundColor: colors.themeGrey,
    },
    saveButton: {
        ...buttons.base,
        ...buttons.mediumWidth,
        float: 'right',
        marginLeft: spacings.small,
        marginRight: spacings.small,
    },
    buttonRow: {
        height: '50px',
    },
    flex: {
        display: 'flex',
        justifyContent: 'center',
        gap: '1rem',
        alignItems: 'center',
        margin: "1rem"
    }
};


const AwardBonusGemsModal = ({ t, 
                                 onDeleteAnnouncement,
                                 onClose,
                                 deleteModalRef,
                                 required,
                                 roles,
                                 ...props
                               }) => {

    const fileSelector = createRef()
    const [gemsToAward, setGemsToAward] = useState()
    const [rewardActionToAward, setRewardActionToAward] = useState()
    const [csvData, setCsvData] = useState()
    const [batchesCompleted, setBatchesCompleted] = useState(0)
    const [totalBatches, setTotalBatches] = useState(0)
    const [isSubmitting, setIsSubmitting] = useState(false)
    const dispatch = useDispatch()

    const onUploadCsv = () => {
        fileSelector.current.click();
    }

    const onFileSelect = (event) => {
        const [file,] = event.target.files

        if (file.type != 'text/csv'){
            window.alert('Invalid CSV File')
            return
        }
        dispatch({type: SET_LOADING_OVERLAY_ENABLE, enable:true});
        event.target.value=null
        
        const reader = new FileReader();
        reader.onerror= (e) => { 
            window.alert(e)
            dispatch({type: SET_LOADING_OVERLAY_ENABLE, enable:false})
        };
        reader.onload = async (e) => {
            console.log(e)
            setCsvData(e.target.result.replace(/^[^\n]*\r?\n?/, ''))
            dispatch({type: SET_LOADING_OVERLAY_ENABLE, enable:false});
        };
        reader.readAsText(file, 'UTF-8');
    }

    const onChangeCsvData = async (e) => {
        setCsvData(e.target.value)
    }

    const onSubmit = async (event) => {
        event && event.preventDefault();

        const lines = splitCsvDataLines(csvData)
        if (lines.length === 0) {
            window.alert('No user rows to submit.')
            return
        }

        const firstLineLength = lines[0].split(',').length
        const headers = ['email', 'resources', 'rewardActionId']
        const headerRow = headers.slice(0, firstLineLength).join(',')

        const batchCount = Math.ceil(lines.length / BONUS_GEMS_BATCH_SIZE)
        const showBatchProgress = lines.length > BONUS_GEMS_BATCH_SIZE

        setIsSubmitting(true)
        setBatchesCompleted(0)
        setTotalBatches(showBatchProgress ? batchCount : 0)

        dispatch({ type: SET_LOADING_OVERLAY_ENABLE, enable: true })
        let remaining = [...lines]
        let completed = 0

        try {
            while (remaining.length > 0) {
                const chunk = remaining.slice(0, BONUS_GEMS_BATCH_SIZE)
                const chunkCsv = joinCsvDataLines(chunk)

                await DatabaseService.awardBonusGems({
                    resources: gemsToAward,
                    rewardActionId: rewardActionToAward,
                    companyEmployees: { csv: `${headerRow}\r\n${chunkCsv}` },
                })

                remaining = remaining.slice(BONUS_GEMS_BATCH_SIZE)
                completed += 1
                setCsvData(remaining.length ? joinCsvDataLines(remaining) : '')
                setBatchesCompleted(completed)
            }

            onClose()
        } catch (err) {
            window.alert('An error occurred - check logs')
            console.error(err)
        } finally {
            dispatch({ type: SET_LOADING_OVERLAY_ENABLE, enable: false })
            setIsSubmitting(false)
        }
    }

    const handleModalClose = () => {
        if (isSubmitting) return
        onClose()
    }
    
    return (
        <Modal open style={style.content} onClose={handleModalClose} closeOnDimmerClick={!isSubmitting} size='small'>
            <Modal.Content>
                {/* <DeletePromptContainer ref = {deleteModalRef} onDeleteConfirmation = {onDeleteAnnouncement} /> */}
                <Modal.Description>
                    <Modal.Header>
                        <div style={{...style.flex, fontSize: fontSizes.h4}}>
                            Award Bonus Gems
                        </div>
                    </Modal.Header>
                    <Form onSubmit={onSubmit}>
                        <div style={style.flex}>
                            <span>Global Bonus Gems (optional): </span>
                            <input type='number' placeholder='Enter gems' 
                                style={{width:'auto', padding: '0.5rem'}}
                                disabled={isSubmitting}
                                onChange={(e)=>setGemsToAward(e.target.value)}
                                />
                            
                        
                        </div>
                        { localStorage.master == 'true' && <div style={style.flex}>
                            <span>Global Bonus Reward Action (optional): </span>
                            <input type='number' placeholder='Enter Reward Action ID' 
                                style={{width:'auto', padding: '0.5rem'}}
                                disabled={isSubmitting}
                                onChange={(e)=>setRewardActionToAward(e.target.value)}
                                />
                        </div> }
                        <div>

                        <div style={{ textAlign:"center", fontSize: fontSizes.h4}}>
                            Users and Individual Bonuses
                        </div>
                            <TextArea rows="10"
                                placeholder={`email,resources,rewardActionId
...`}
                                value={csvData || ''}
                                readOnly={isSubmitting}
                                onChange={onChangeCsvData}></TextArea>
                            {totalBatches > 1 && isSubmitting && (
                                <div style={{ textAlign: 'center', marginTop: '0.75rem', fontSize: fontSizes.body }}>
                                    {batchesCompleted}/{totalBatches} batches completed
                                </div>
                            )}
                            <input ref={fileSelector} type="file" style={{display:'none'}} onChange={onFileSelect} />
                            <span>Upload Users (CSV): </span>
                            <Button type='button' style={style.button} disabled={isSubmitting}
                                onClick={onUploadCsv}>{t('Upload Users')}
                            </Button>
                         
                        </div>
                        <div>
                            NOTE - csv must include the title "email" (all lowercase) in column A followed by list of emails in rows below it. The columns "resources" and "rewardActionId" are optional.
                        </div>
                            
                        <div style={style.flex}>
                            <Button style={style.saveButton} disabled={!Boolean(csvData) || isSubmitting} type='submit'>{t('Save')}</Button>
                        </div>
                       
                        
                    </Form>
                </Modal.Description>
            </Modal.Content>
        </Modal>
    )
}

export default withTranslation('announcements')(AwardBonusGemsModal);
